/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from "react";
import { string, object } from "prop-types";
import { RCL as useTranslation, RCL } from "../RCL";
import useGatsbyAuth from "../../templates/user-account/hook/useGatsbyAuth";
import { HeaderScripts } from "./HeaderScripts";
import "./vf-search-all.scss";
import "./vf-bootstrap.scss";

const cloudinaryBase = "https://assets.sunwingtravelgroup.com/image/upload";
let hasInitialized = false;

const VFinder = ({ language, config }) => {
	const { loading } = useGatsbyAuth();

	const handleLoadScripts = scripts =>
		scripts
			.map(({ script, checkCondition }) => {
				if (typeof checkCondition === "function" && !checkCondition()) {
					const scriptEl = document.createElement("script");
					scriptEl.src = script;
					scriptEl.async = false;
					scriptEl.crossOrigin = "anonymous";
					document.body.appendChild(scriptEl);
					return scriptEl;
				}
				return null;
			})
			.filter(x => x);

	useEffect(() => {
		if (!loading && !hasInitialized) {
			hasInitialized = true;

			const loadedScripts = [
				{
					script: "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.14.1/moment.min.js",
					checkCondition: () => window.moment,
				},
				{
					script: "https://cdnjs.cloudflare.com/ajax/libs/jquery/1.11.3/jquery.min.js",
					checkCondition: () => window.$?.fn,
				},
				{
					script: "https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.11.4/jquery-ui.min.js",
					checkCondition: () => window.$?.ui,
				},
				{
					script:
						"https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.7/js/bootstrap.min.js",
					checkCondition: () => window.$?.fn?.modal,
				},
				{
					script:
						"https://cdnjs.cloudflare.com/ajax/libs/bootstrap-daterangepicker/2.1.25/daterangepicker.min.js",
					checkCondition: () => window.$?.fn?.daterangepicker,
				},
				{
					script:
						"https://cdn.jsdelivr.net/npm/responsive-toolkit@2.6.3/src/bootstrap-toolkit.min.js",
					checkCondition: () => window.ResponsiveBootstrapToolkit,
				},
				{
					script: "https://cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie.min.js",
					checkCondition: () => window.$?.cookie,
				},
			];

			handleLoadScripts(loadedScripts);
		}
	}, [loading]);

	useEffect(() => {
		let scripts;

		if (!loading) {
			scripts = handleLoadScripts([
				{
					script: "/assets/vacation-finder/vf-search-all.js",
					checkCondition: () => window.SWGVacationSearch,
				},
			]);

			window.vfConfig = config;
		}

		return () => {
			if (scripts) {
				scripts.forEach(script => script.parentNode.removeChild(script));
				delete window.vfConfig;

				if (window.SWGVacationSearch?.dataView?.destroy) {
					window.SWGVacationSearch.dataView.destroy();
				}
				if (window.SWGApplication?.dataView?.destroy) {
					window.SWGApplication.dataView.destroy();
					hasInitialized = false;
				}
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loading]);

	return (
		<>
			<HeaderScripts />
			<div id="body-content" className="vf-application" role="main">
				<div id="page-content" lang={language}>
					<div className="vf-search-box">
						<div className="container relative">
							<a role="button" href="#" id="vf-search-toggle">
								<span className="search-copy">
									<RCL searchKey="vf-hide-your-search" />
								</span>
								<span className="search-arrow" />
							</a>
							{/* START Page Content */}
							<div className="page-content-container vf-padding">
								<div className="vf-wrapper">
									<div className="search-container dt">
										<div className="description dtc">
											<div className="row dt">
												<div className="col-xs-12">
													<div className="row dt">
														<div className="col-xs-1 dtc">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																viewBox="0 0 1448 1452"
																style={{ display: "none" }}>
																<defs>
																	<g id="vacation-finder-icon">
																		<path
																			d="M1407.887,1363.104l-384.28-384.293c95.772-105.646,148.388-241.406,148.388-384.609
																					c0-316.131-257.194-573.324-573.324-573.324c-316.136,0-573.337,257.193-573.337,573.324c0,316.129,257.201,573.322,573.337,573.322
																					c132.541,0,257.611-44.574,359.022-126.479l386.127,386.127c8.849,8.848,20.429,13.273,32.033,13.273
																					c11.593,0,23.186-4.426,32.034-13.273C1425.585,1409.484,1425.585,1380.789,1407.887,1363.104z M945.165,930.215
																					c-13.539,13.957-27.824,26.877-42.653,38.949c-48.417-54.32-171.591-173.721-334.788-194.605c-1.985-0.252-3.938-0.418-5.917-0.658
																					l58.992-211.494l74.82-21.504l69.288,70.504l85.888-21.555l77.885,69.971c51.995-259.975-196.059-407.161-196.059-407.161
																					l-15.107-38.064c0,0-2.996-1.163-39.694,25.764c-331.021,16.03-393.951,232.454-393.951,232.454l94.736-12.855l59.023,57.455
																					l100.488-14.625l57.545,53.385l-60.022,215.174C376.31,758.922,240.747,806.34,179.29,832.773
																					c-40.226-70.426-63.341-151.826-63.341-238.572c0-266.171,216.545-482.709,482.721-482.709
																					c266.157,0,482.709,216.538,482.709,482.709C1081.379,720.326,1033.012,839.65,945.165,930.215z"
																		/>
																	</g>
																</defs>
															</svg>
															<svg viewBox="0 0 1448 1452">
																<use xlinkHref="#vacation-finder-icon" />
															</svg>
														</div>
														<div className="col-xs-11 no-gutter dtc">
															<h1>
																<RCL searchKey="vacation-finder-title" />
															</h1>
														</div>
													</div>
												</div>
												<div className="col-xs-12" />
											</div>
											<h2>
												<RCL searchKey="vf-subtitle" />
											</h2>
											<p>
												<RCL searchKey="vf-search-description" />
											</p>
										</div>
										<div className="input-container dtc">
											<div className="error-bg" />
											<div className="flyout-container">
												<div id="vacation-finder-form">
													<div className="form-group vf-departure-gateways">
														<span className="fa-icon-47 icon" aria-hidden="true">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.53 17.57">
																<g id="departure-icon">
																	<path
																		d="M7.27,2.81c-.62-.05-1.15.7-1.54,1.12L7.6,5l3.12-1.51A23.46,23.46,0,0,0,7.27,2.81Z"
																		transform="translate(-0.64 -1.33)"
																	/>
																	<path
																		d="M10.2,7.89,10,14c.56-.1,1.49-.15,1.77-.71a38.3,38.3,0,0,0,2.31-6.85l5.58-2.5c1-.77.93-1.55.73-1.92-.36-.67-1.46-.69-1.46-.69C15.33,1.25,4,7.85,4,7.85,1,5.79.64,6.5.64,6.5a30.48,30.48,0,0,0,2.17,3l-.67,2.69c.94,0,2.08-2.27,2.08-2.27Z"
																		transform="translate(-0.64 -1.33)"
																	/>
																	<rect x="0.34" y="16.49" width="20.19" height="1.08" />
																</g>
															</svg>
														</span>
														<label htmlFor="departure-gateways">
															<RCL searchKey="vf-depart-from" />
														</label>
														<div className="input-group">
															<div className="expansion-group">
																<a
																	role="button"
																	href="#"
																	className="close-expansion fa-icon-47 fa-close fa-fw"
																	aria-hidden="true"
																	aria-label={RCL({
																		searchKey: "modal-close",
																	})}>
																	<span aria-hidden="false">
																		<svg
																			viewBox="0 0 1792 1792"
																			xmlns="http://www.w3.org/2000/svg"
																			style={{
																				width: "1.5rem",
																				height: "1rem",
																			}}>
																			<path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
																		</svg>
																	</span>
																</a>
																<div className="form-group checkbox-group fa-checkbox-theme1 dt">
																	<fieldset>
																		<legend className="sr-only" />
																		<div className="input dtc">
																			<input
																				name="gateway-expand"
																				id="gateway-expand"
																				type="checkbox"
																			/>
																			<span className="gateway-expand-label" />
																		</div>
																		<label htmlFor="gateway-expand" className="expand-text dtc" />
																	</fieldset>
																</div>
															</div>
															<div className="input-wrapper gradient">
																<input
																	id="departure-gateways"
																	name="departure-gateways"
																	type="text"
																	className="form-control"
																	aria-label={RCL({
																		searchKey: "vf-select-your-departure-gateways",
																	})}
																	readOnly
																	tabIndex={-1}
																/>
															</div>
															<div className="input-group-btn">
																<button
																	type="button"
																	className="btn btn-default dropdown-toggle"
																	data-toggle="dropdown"
																	aria-haspopup="true"
																	aria-expanded="false">
																	<span className="dd-arrow" />
																	<span className="sr-only">
																		<RCL searchKey="vf-toggle-the-gateway-drop-down" />
																	</span>
																</button>
																{/* START Custom Dropdown / Modal */}
																<div
																	className="dropdown-menu modal light-blue-theme"
																	tabIndex={-1}
																	role="dialog"
																	aria-labelledby="modalTitleGateways">
																	<div className="modal-dialog modal-lg" role="document">
																		<div className="modal-content">
																			<div className="modal-header">
																				<button
																					type="button"
																					className="close"
																					data-dismiss="modal"
																					aria-label={RCL({
																						searchKey: "modal-close",
																					})}>
																					<span aria-hidden="false">
																						<svg
																							viewBox="0 0 1792 1792"
																							xmlns="http://www.w3.org/2000/svg">
																							<path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
																						</svg>
																					</span>
																				</button>
																				<span
																					className="modal-title heading-h2"
																					id="modalTitleGateways">
																					<RCL searchKey="vf-select-your-departure-gateways" />
																				</span>
																			</div>
																			<div className="modal-body">
																				<div className="menu-wrapper dt">
																					<span className="heading-large dtc">
																						<RCL searchKey="vf-select-up-to-4-departure-gateways" />
																					</span>
																					<a
																						role="button"
																						href="#"
																						className="clear-all underline dtc">
																						<RCL searchKey="clear-all" />
																					</a>
																				</div>
																				<div className="menu-checkbox-list">
																					<div className="checkbox-list">
																						<div className="vf-loader">
																							<span
																								className="swg-orange fa-icon-47 fa-fw fa-3x fa-spinner fa-pulse"
																								aria-hidden="true"
																							/>
																						</div>
																						<div className="form-group list-group columns4 checkbox-group fa-checkbox-theme1 break-inside-avoid hide" />
																					</div>
																				</div>
																			</div>
																			<div className="modal-footer">
																				<button
																					type="button"
																					className="btn btn-default full-width-xs"
																					data-dismiss="modal">
																					<RCL searchKey="done" />
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
																{/* END Custom Dropdown / Modal */}
															</div>
														</div>
													</div>
													<div className="form-group vf-arrival-destinations">
														<span className="fa-icon-47 fa-map-marker icon" aria-hidden="true">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1536">
																<g id="map-location-icon">
																	<path d="M768,512q0-106-75-181T512,256q-106,0-181,75T256,512q0,106,75,181t181,75q106,0,181-75T768,512Zm256,0q0,109-33,179L627,1465a121.39,121.39,0,0,1-47.5,52,129.4,129.4,0,0,1-135,0,115.2,115.2,0,0,1-46.5-52L33,691Q0,621,0,512,0,300,150,150T512,0Q724,0,874,150T1024,512Z" />
																</g>
															</svg>
														</span>

														<label htmlFor="arrival-destinations">
															<RCL searchKey="vf-going-to" />
														</label>
														<div className="input-group">
															<div className="input-wrapper gradient">
																<input
																	id="arrival-destinations"
																	name="arrival-destinations"
																	type="text"
																	className="form-control"
																	aria-label={RCL({
																		searchKey: "vf-select-your-destinations",
																	})}
																	readOnly
																	tabIndex={-1}
																/>
															</div>
															<div className="input-group-btn">
																<button
																	type="button"
																	className="btn btn-default dropdown-toggle"
																	data-toggle="dropdown"
																	aria-haspopup="true"
																	aria-expanded="false">
																	<span className="dd-arrow" />
																	<span className="sr-only">
																		<RCL searchKey="vf-toggle-the-destination-drop-down" />
																	</span>
																</button>
																<div
																	className="dropdown-menu modal light-blue-theme"
																	tabIndex={-1}
																	role="dialog"
																	aria-labelledby="modalTitleDestination">
																	<div className="modal-dialog modal-lg" role="document">
																		<div className="modal-content">
																			<div className="modal-header">
																				<button
																					type="button"
																					className="close"
																					data-dismiss="modal"
																					aria-label={RCL({
																						searchKey: "modal-close",
																					})}>
																					<span aria-hidden="false">
																						<svg
																							viewBox="0 0 1792 1792"
																							xmlns="http://www.w3.org/2000/svg">
																							<path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
																						</svg>
																					</span>
																				</button>
																				<h2 className="modal-title" id="modalTitleDestination">
																					<RCL searchKey="destinations" />
																				</h2>
																			</div>
																			<div className="modal-body">
																				<div className="menu-wrapper dt">
																					<span className="heading-large dtc">
																						<RCL searchKey="vf-select-your-destinations" />
																					</span>
																					<a
																						role="button"
																						href="#"
																						className="clear-all underline dtc">
																						<RCL searchKey="clear-all" />
																					</a>
																				</div>
																				<div className="menu-checkbox-list">
																					<div className="checkbox-list">
																						<div className="vf-loader">
																							<span className="swg-orange fa-icon-47 fa-fw fa-3x fa-spinner fa-pulse" />
																						</div>
																						<div className="form-group list-group columns3 checkbox-group fa-checkbox-theme1 break-inside-avoid hide" />
																					</div>
																				</div>
																			</div>
																			<div className="modal-footer">
																				<button
																					type="button"
																					className="btn btn-default full-width-xs"
																					data-dismiss="modal">
																					<RCL searchKey="done" />
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="form-group vf-travel-date-range">
														<span className="fa-icon-47 fa-calendar icon" aria-hidden="true">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792">
																<g id="calendar-icon">
																	<path d="M192 1664h288v-288H192v288zm352 0h320v-288H544v288zm-352-352h288V992H192v320zm352 0h320V992H544v320zM192 928h288V640H192v288zm736 736h320v-288H928v288zM544 928h320V640H544v288zm768 736h288v-288h-288v288zm-384-352h320V992H928v320zM576 448V160q0-13-9.5-22.5T544 128h-64q-13 0-22.5 9.5T448 160v288q0 13 9.5 22.5T480 480h64q13 0 22.5-9.5T576 448zm736 864h288V992h-288v320zM928 928h320V640H928v288zm384 0h288V640h-288v288zm32-480V160q0-13-9.5-22.5T1312 128h-64q-13 0-22.5 9.5T1216 160v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm384-64v1280q0 52-38 90t-90 38H192q-52 0-90-38t-38-90V384q0-52 38-90t90-38h128v-96q0-66 47-113T480 0h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z" />
																</g>
															</svg>
														</span>
														<label htmlFor="travel-calendar">
															<RCL searchKey="vf-travel-dates" />
														</label>
														<div className="right-inner-icon">
															<button
																id="travel-calendar"
																type="button"
																name="travel-calendar"
																className="btn btn-default full-width range-calendar">
																<span className="heading" />
																<span className="range">
																	<span className="dep-date">MM/DD</span>
																	<span className="preposition" />
																	<span className="arr-date">MM/DD</span>
																</span>
															</button>
															<span className="fa-icon-47 fa-calendar-o fa-fw" aria-hidden="true" />
														</div>
													</div>
													<div className="form-group vf-duration">
														<span className="fa-icon-47 icon" aria-hidden="true">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.72 15.73">
																<rect width="12.72" height="1.49" />
																<rect y="14.24" width="12.72" height="1.49" />
																<path
																	d="M11,9.42C10,7.05,7.63,5.54,7.63,4.05h6.73C14.37,5.68,11.83,7.09,11,9.42Z"
																	transform="translate(-4.64 -2.14)"
																/>
																<path
																	d="M11,9.91c1,1.65,3.82,3.19,3.82,5.82H7.2C7.2,13,9.85,11.63,11,9.91Z"
																	transform="translate(-4.64 -2.14)"
																/>
																<path
																	d="M6.77,3H5.08a11.17,11.17,0,0,0,3,6.87A11.77,11.77,0,0,0,5,17H6.48c0-2,.73-5,2.35-6.46.15-.13,1-.71,1.14-.82-.16-.12-1.13-.82-1.28-1C7.07,7.23,6.77,5,6.77,3Z"
																	transform="translate(-4.64 -2.14)"
																/>
																<path
																	d="M15.24,3h1.69a11.17,11.17,0,0,1-3,6.87A11.77,11.77,0,0,1,17,17H15.53c0-2-.73-5-2.35-6.46-.15-.13-1-.71-1.14-.82.16-.12,1.13-.82,1.28-1C14.94,7.23,15.24,5,15.24,3Z"
																	transform="translate(-4.64 -2.14)"
																/>
															</svg>
														</span>
														<label htmlFor="duration">
															<RCL searchKey="vf-how-long" />
														</label>
														<select name="duration" id="duration" defaultValue="aroundoneweek">
															<option value="aroundoneweek">
																{useTranslation({
																	searchKey: "vf-around-a-week",
																})}
															</option>
															<option value="shortstay">
																{useTranslation({ searchKey: "vf-a-few-days" })}
															</option>
															<option value="aroundtendays">
																{useTranslation({
																	searchKey: "vf-around-10-nights",
																})}
															</option>
															<option value="aroundtwoweeks">
																{useTranslation({
																	searchKey: "vf-around-2-weeks",
																})}
															</option>
															<option value="longstay">
																{useTranslation({ searchKey: "vf-long-stay" })}
															</option>
														</select>
													</div>
													<div className="form-group vf-adults">
														<span className="fa-icon-47 icon svg-icon" aria-hidden="true">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																viewBox="0 0 12.02 16.51"
																title={RCL({ searchKey: "adults" }).concat(
																	" ",
																	RCL({ searchKey: "18-yrs" })
																)}>
																<circle cx="6.01" cy="3.19" r="3.19" />
																<path
																	d="M17,12.67a3.6,3.6,0,0,0-3.58-3.85A10.12,10.12,0,0,1,11,9.17,10.48,10.48,0,0,1,8.5,8.81C6.69,8.81,5,10.54,5,13.29v4.93H7.44V12.39a.25.25,0,1,1,.5,0v5.82h6.23V12.39a.25.25,0,1,1,.5,0v5.82H17Z"
																	transform="translate(-4.99 -1.71)"
																/>
															</svg>
														</span>
														{/* <img
															src={cloudinaryBase.concat("/Dev/vacation-finder/icons/man-icon.svg")}
															className="svg-icon"
															alt={RCL({ searchKey: "adults" }).concat(
																" ",
																RCL({ searchKey: "18-yrs" })
															)}
															aria-hidden="true"
														/> */}
														<label htmlFor="adults">
															<RCL searchKey="adults" />
															<span>
																<RCL searchKey="18-yrs" />
															</span>
														</label>
														<select id="adults" name="adults" defaultValue="2">
															<option value={1}>1</option>
															<option value={2}>2</option>
															<option value={3}>3</option>
															<option value={4}>4</option>
															<option value={5}>5</option>
															<option value={6}>6</option>
														</select>
													</div>
													<div className="form-group vf-children">
														<span className="fa-icon-47 icon" aria-hidden="true">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																viewBox="0 0 12.02 16.51"
																title={RCL({ searchKey: "children" }).concat(
																	" ",
																	RCL({ searchKey: "0-17-yrs" })
																)}>
																<circle cx="6.01" cy="3.19" r="3.19" />
																<path
																	d="M17,12.67a3.6,3.6,0,0,0-3.58-3.85A10.12,10.12,0,0,1,11,9.17,10.48,10.48,0,0,1,8.5,8.81C6.69,8.81,5,10.54,5,13.29v4.93H7.44V12.39a.25.25,0,1,1,.5,0v5.82h6.23V12.39a.25.25,0,1,1,.5,0v5.82H17Z"
																	transform="translate(-4.99 -1.71)"
																/>
															</svg>
														</span>

														<label htmlFor="children">
															<RCL searchKey="children" />{" "}
															<span>
																<RCL searchKey="0-17-yrs" />
															</span>
														</label>
														<div className="right-inner-icon">
															<input
																id="children"
																type="text"
																name="children"
																className="btn full-width"
																readOnly
																defaultValue={0}
															/>
															<span
																className="fa-icon-47 fa-pencil-square-o fa-fw"
																aria-hidden="true"
															/>
														</div>
													</div>
													<div className="form-group vf-features">
														<span className="fa-icon-47 icon" aria-hidden="true">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.89 17.5">
																<path
																	d="M5.16,10.92,2.58,16.54l3.82-1,1.72,3.55,2.24-4.88A6.8,6.8,0,0,1,5.16,10.92Z"
																	transform="translate(-2.58 -1.58)"
																/>
																<path
																	d="M16.87,10.87a6.81,6.81,0,0,1-5.17,3.33l2.24,4.88,1.72-3.55,3.82,1Z"
																	transform="translate(-2.58 -1.58)"
																/>
																<path
																	d="M11,1.58a5.84,5.84,0,0,0-4.88,9L11,12.86l-.18.4h.47l-.18-.4,4.79-2.2A5.84,5.84,0,0,0,11,1.58Zm2.07,9L11,9.52,8.93,10.61l.4-2.31L7.65,6.67,10,6.34l1-2.1,1,2.1,2.32.34L12.68,8.31Z"
																	transform="translate(-2.58 -1.58)"
																/>
																<path
																	d="M6.12,10.63a5.83,5.83,0,0,0,4.67,2.63l.18-.4Z"
																	transform="translate(-2.58 -1.58)"
																/>
																<path
																	d="M11.26,13.26a5.83,5.83,0,0,0,4.6-2.59l-4.79,2.2Z"
																	transform="translate(-2.58 -1.58)"
																/>
															</svg>
														</span>

														<label htmlFor="recommended-features">
															<RCL searchKey="vf-recommended-for" />
														</label>
														<div className="input-group">
															<div className="input-wrapper gradient">
																<input
																	id="recommended-features"
																	name="recommended-features"
																	type="text"
																	className="form-control"
																	aria-label={RCL({
																		searchKey: "vf-recommended-features",
																	})}
																	readOnly
																	tabIndex={-1}
																/>
															</div>
															<div className="input-group-btn">
																<button
																	type="button"
																	className="btn btn-default dropdown-toggle"
																	data-toggle="dropdown"
																	aria-haspopup="true"
																	aria-expanded="false">
																	<span className="dd-arrow" />
																	<span className="sr-only">
																		<RCL searchKey="vf-toggle-recommended-features-drop-down" />
																	</span>
																</button>
																<div
																	className="dropdown-menu modal light-blue-theme"
																	tabIndex={-1}
																	role="dialog"
																	aria-labelledby="modalTitleRecommended">
																	<div className="modal-dialog modal-lg" role="document">
																		<div className="modal-content">
																			<div className="modal-header">
																				<button
																					type="button"
																					className="close"
																					data-dismiss="modal"
																					aria-label={RCL({
																						searchKey: "modal-close",
																					})}>
																					<span aria-hidden="false">
																						<svg
																							viewBox="0 0 1792 1792"
																							xmlns="http://www.w3.org/2000/svg">
																							<path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
																						</svg>
																					</span>
																				</button>
																				<h2 className="modal-title" id="modalTitleRecommended">
																					<RCL searchKey="vf-recommended-features" />
																				</h2>
																			</div>
																			<div className="modal-body">
																				<div className="menu-wrapper dt">
																					<span className="heading-large dtc">
																						<RCL searchKey="vf-your-results-will-be-prioritized-by-applying-these-items" />
																					</span>
																					<a
																						role="button"
																						href="#"
																						className="clear-all underline dtc">
																						<RCL searchKey="clear-all" />
																					</a>
																				</div>
																				<div className="menu-checkbox-list">
																					<div className="checkbox-list">
																						<div className="form-group list-group columns3 checkbox-group fa-checkbox-theme1 break-inside-avoid">
																							<fieldset>
																								<legend className="sr-only" />
																								<div className="group-item">
																									<div className="list-heading">
																										<label>
																											<RCL searchKey="vf-ideal-for" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="ideal-adults"
																											name="ideal-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="ideal-adults">
																											<RCL searchKey="adults" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="ideal-families"
																											name="ideal-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="ideal-families">
																											<RCL searchKey="families" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="ideal-luxury"
																											name="ideal-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="ideal-luxury">
																											<RCL searchKey="luxury" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="ideal-singles"
																											name="ideal-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="ideal-singles">
																											<RCL searchKey="singles" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="ideal-students"
																											name="ideal-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="ideal-students">
																											<RCL searchKey="students" />
																										</label>
																									</div>
																								</div>
																								<div className="group-item">
																									<div className="list-heading">
																										<label>
																											<RCL searchKey="vf-top-rated-for" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="top-value"
																											name="top-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="top-value">
																											<RCL searchKey="value-for-money" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="top-accommodations"
																											name="top-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="top-accommodations">
																											<RCL searchKey="accommodations" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="top-service"
																											name="top-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="top-service">
																											<RCL searchKey="service" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="top-beach"
																											name="top-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="top-beach">
																											<RCL searchKey="beach" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="top-pools"
																											name="top-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="top-pools">
																											<RCL searchKey="pools" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="top-dining"
																											name="top-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="top-dining">
																											<RCL searchKey="dining" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="top-entertainment"
																											name="top-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="top-entertainment">
																											<RCL searchKey="entertainment" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="top-sports"
																											name="top-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="top-sports">
																											<RCL searchKey="sports" />
																										</label>
																									</div>
																								</div>
																							</fieldset>
																						</div>
																					</div>
																				</div>
																			</div>
																			<div className="modal-footer">
																				<button
																					type="button"
																					className="btn btn-default full-width-xs"
																					data-dismiss="modal">
																					<RCL searchKey="done" />
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="form-group vf-features-other">
														<span className="fa-icon-47 fa-check-square-o icon" aria-hidden="true">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																viewBox="0 0 1792 1792"
																style={{ display: "none" }}>
																<g id="check-square-o-icon">
																	<path d="M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z" />
																</g>
															</svg>
															<svg viewBox="0 0 1792 1792">
																<use xlinkHref="#check-square-o-icon" />
															</svg>
														</span>
														<label htmlFor="other-features">
															<RCL searchKey="also-important-optional" />
														</label>
														<div className="input-group">
															<div className="input-wrapper gradient">
																<input
																	id="other-features"
																	name="other-features"
																	type="text"
																	className="form-control"
																	aria-label={RCL({
																		searchKey: "other-important-features",
																	})}
																	readOnly
																	tabIndex={-1}
																/>
															</div>
															<div className="input-group-btn">
																<button
																	type="button"
																	className="btn btn-default dropdown-toggle"
																	data-toggle="dropdown"
																	aria-haspopup="true"
																	aria-expanded="false">
																	<span className="dd-arrow" />
																	<span className="sr-only">
																		<RCL searchKey="toggle-other-important-features-drop-down" />
																	</span>
																</button>
																<div
																	className="dropdown-menu modal light-blue-theme"
																	tabIndex={-1}
																	role="dialog"
																	aria-labelledby="modalTitleAlso">
																	<div className="modal-dialog modal-lg" role="document">
																		<div className="modal-content">
																			<div className="modal-header">
																				<button
																					type="button"
																					className="close"
																					data-dismiss="modal"
																					aria-label={RCL({
																						searchKey: "modal-close",
																					})}>
																					<span aria-hidden="false">
																						<svg
																							viewBox="0 0 1792 1792"
																							xmlns="http://www.w3.org/2000/svg">
																							<path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
																						</svg>
																					</span>
																				</button>
																				<span
																					className="modal-title heading-h2"
																					id="modalTitleAlso">
																					<RCL searchKey="other-important-features" />
																				</span>
																			</div>
																			<div className="modal-body">
																				<div className="menu-wrapper dt">
																					<span className="heading-large dtc">
																						<RCL searchKey="your-results-will-be-prioritized-by-applying-these-items" />
																					</span>
																					<a
																						role="button"
																						href="#"
																						className="clear-all underline dtc">
																						<RCL searchKey="clear-all" />
																					</a>
																				</div>
																				<div className="menu-checkbox-list">
																					<div className="checkbox-list">
																						<div className="form-group list-group columns2 checkbox-group fa-checkbox-theme1 break-inside-avoid">
																							<fieldset>
																								<legend className="sr-only" />
																								<div className="group-item">
																									<div className="list-heading">
																										<label>
																											<RCL searchKey="facilities-and-services" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-all-inclusive"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-all-inclusive">
																											<RCL searchKey="all-inclusive" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-accessibility"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-accessibility">
																											<RCL searchKey="accessibility" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-casino"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-casino">
																											<RCL searchKey="casino" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-fitness-centre"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-fitness-centre">
																											<RCL searchKey="fitness-centre" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-golf"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-golf">
																											<RCL searchKey="golf" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-spa"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-spa">
																											<RCL searchKey="spa" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-supervised-kids-club"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-supervised-kids-club">
																											<RCL searchKey="supervised-kids-club" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-butler-service"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-butler-service">
																											<RCL searchKey="butler-service" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-tennis"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-tennis">
																											<RCL searchKey="tennis" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-waterpark"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-waterpark">
																											<RCL searchKey="water-park" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-wifi-connectivity"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-wifi-connectivity">
																											<RCL searchKey="wifi-connectivity" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-larger-hotels"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-larger-hotels">
																											<RCL searchKey="larger-hotels-over-500-rooms" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="facilities-smaller-hotels"
																											name="facilities-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="facilities-smaller-hotels">
																											<RCL searchKey="smaller-hotels-less-than-250-rooms" />
																										</label>
																									</div>
																								</div>
																								<div className="group-item">
																									<div className="list-heading">
																										<label>
																											<RCL searchKey="room" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="room-premium-room"
																											name="room-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="room-premium-room">
																											<RCL searchKey="premium-room" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="room-view-from-room"
																											name="room-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="room-view-from-room">
																											<RCL searchKey="view-from-room" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="room-room-service"
																											name="room-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="room-room-service">
																											<RCL searchKey="room-service" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="room-mini-bar"
																											name="room-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="room-mini-bar">
																											<RCL searchKey="mini-bar" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="room-kitchenette"
																											name="room-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="room-kitchenette">
																											<RCL searchKey="kitchenette" />
																										</label>
																									</div>
																								</div>
																								<div className="group-item">
																									<div className="list-heading">
																										<label>
																											<RCL searchKey="other" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="other-shorter-airport-transfer"
																											name="other-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="other-shorter-airport-transfer">
																											<RCL searchKey="shorter-airport-transfer" />
																										</label>
																									</div>
																									<div className="list-item">
																										<input
																											id="other-shorter-flying-time"
																											name="other-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="other-shorter-flying-time">
																											<RCL searchKey="shorter-flying-time" />
																										</label>
																									</div>
																									<div className="list-item other">
																										<input
																											id="other-other"
																											name="other-group"
																											type="checkbox"
																											defaultValue
																										/>
																										<label htmlFor="other-other">
																											<RCL searchKey="other-please-specify-keyword" />
																										</label>
																										<label
																											htmlFor="other-custom"
																											className="input-message clearfix">
																											<RCL searchKey="let-us-know-whats-important-to-you" />
																										</label>
																										<input
																											id="other-custom"
																											className="visible-off"
																											name="other-custom"
																											type="text"
																											defaultValue=""
																										/>
																									</div>
																								</div>
																							</fieldset>
																						</div>
																					</div>
																				</div>
																			</div>
																			<div className="modal-footer">
																				<button
																					type="button"
																					className="btn btn-default full-width-xs"
																					data-dismiss="modal">
																					<RCL searchKey="done" />
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="form-group vf-search">
														<a role="button" href="#" className="reset">
															<RCL searchKey="reset-all" />
														</a>
														<button type="button" className="btn">
															<span className="cta">
																<RCL searchKey="show-my-result" />{" "}
																<span className="fa-icon-47 fa-search fa-fw" aria-hidden="true" />
															</span>
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div id="vf-search-errors">
									<div className="error-message dt">
										<div className="dtc icon">
											<span className="fa-icon-47 fa-exclamation-circle fa-fw" aria-hidden="true" />
										</div>
										<div
											className="dtc message"
											aria-label={RCL({
												searchKey: "sorry-no-results-are-available-based-on-your-filter-settings",
											})}>
											<p />
											<div className="alternate-dates" />
										</div>
										<div className="dtc close-icon" aria-label={RCL({ searchKey: "modal-close" })}>
											<span className="fa-icon-47 fa-close fa-fw" aria-hidden="false" />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div id="vf-search-container" className="container">
						<div className="vf-result-filters-anchor">
							<div id="vf-result-filters" className="sticky-element">
								<div className="result-section">
									<div className="total-wrapper" />
									<div className="compareButtons">
										<div className="viewCompare">
											<a className="viewCompareLink" role="button" />
											<div className="compareList" />
										</div>
									</div>
									<a className="filterToggle" role="button">
										<span className="fa icon fa-icon-47 fa-filter fa-fw" aria-hidden="true" />
									</a>
								</div>
								<div className="result-filter-section">
									<div className="result-filter-group dt">
										<div className="price-range dtc">
											<div className="price-button full-width-dd dtc">
												<div className="btn-group">
													<button
														type="button"
														className="btn dropdown-toggle"
														data-toggle="dropdown"
														aria-haspopup="true"
														aria-expanded="false">
														<span className="icon fa-icon-47 fa-usd" aria-hidden="true" />
														<span className="selection">
															<RCL searchKey="price-range" />
														</span>
													</button>
													<ul className="dropdown-menu">
														<li className="content-wrapper">
															<div className="range-label jq-dropdown-panel">
																<div className="price-label">
																	<span className="title">
																		<RCL searchKey="price-range" />
																	</span>
																	<span className="sub-title">
																		(<RCL searchKey="per-adult" />)
																	</span>
																</div>
																<div className="reset-filters">
																	<a role="button" href="#" className="reset-cta">
																		<span className="title">
																			<RCL searchKey="clear-all" />
																		</span>
																	</a>
																</div>
															</div>
															<div className="range-container">
																<div className="slider-min" />
																<div className="slider-ui" />
																<div className="slider-max" />
															</div>
														</li>
													</ul>
												</div>
											</div>
											<div className="reset-filters-menu full-width-dd dtc">
												<div className="btn-group">
													<button
														type="button"
														className="btn dropdown-toggle reset-cta"
														data-toggle="dropdown"
														aria-haspopup="true"
														aria-expanded="false">
														<span className="icon fa-icon-47 fa-eraser" aria-hidden="true" />
														<span className="selection">
															<RCL searchKey="reset-all-filters" />
														</span>
													</button>
												</div>
											</div>
										</div>
										<div className="filter-icons">
											<div className="gateway full-width-dd dtc">
												<div className="tooltip-notice">
													<div className="tooltip-message dt">
														<label className="tooltip-text dtc">
															<RCL searchKey="view-all-gateways-found" />
														</label>
													</div>
												</div>
												<div className="btn-group">
													<button
														type="button"
														className="btn dropdown-toggle"
														data-toggle="dropdown"
														aria-haspopup="true"
														aria-expanded="false">
														<div className="svg-wrapper" aria-hidden="true">
															<svg
																xmlns="http://www.w3.org/2000/svg"
																viewBox="0 0 20.53 17.57"
																title={RCL({ searchKey: "vf-depart-from" })}>
																<path
																	d="M8.27,2.81c-.62-.05-1.15.7-1.54,1.12L8.6,5l3.12-1.51A23.46,23.46,0,0,0,8.27,2.81Z"
																	transform="translate(-0.64 -1.33)"
																/>
																<path
																	d="M10.2,7.89,10,14c.56-.1,1.49-.15,1.77-.71a38.3,38.3,0,0,0,2.31-6.85l5.58-2.5c1-.77.93-1.55.73-1.92-.36-.67-1.46-.69-1.46-.69C15.33,1.25,4,7.85,4,7.85,1,5.79.64,6.5.64,6.5a30.48,30.48,0,0,0,2.17,3l-.67,2.69c.94,0,2.08-2.27,2.08-2.27Z"
																	transform="translate(-0.64 -1.33)"
																/>
																<rect x="0.34" y="16.49" width="20.19" height="1.08" />
															</svg>
														</div>
														<span className="selection">
															<RCL searchKey="vf-depart-from" />
														</span>
													</button>
													<ul className="dropdown-menu" />
												</div>
											</div>
											<div className="departure-dates full-width-dd dtc">
												<div className="btn-group">
													<button
														type="button"
														className="btn dropdown-toggle"
														data-toggle="dropdown"
														aria-haspopup="true"
														aria-expanded="false">
														<div className="svg-wrapper" aria-hidden="true">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792">
																<path d="M192 1664h288v-288H192v288zm352 0h320v-288H544v288zm-352-352h288V992H192v320zm352 0h320V992H544v320zM192 928h288V640H192v288zm736 736h320v-288H928v288zM544 928h320V640H544v288zm768 736h288v-288h-288v288zm-384-352h320V992H928v320zM576 448V160q0-13-9.5-22.5T544 128h-64q-13 0-22.5 9.5T448 160v288q0 13 9.5 22.5T480 480h64q13 0 22.5-9.5T576 448zm736 864h288V992h-288v320zM928 928h320V640H928v288zm384 0h288V640h-288v288zm32-480V160q0-13-9.5-22.5T1312 128h-64q-13 0-22.5 9.5T1216 160v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zm384-64v1280q0 52-38 90t-90 38H192q-52 0-90-38t-38-90V384q0-52 38-90t90-38h128v-96q0-66 47-113T480 0h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z" />
															</svg>
														</div>

														<span className="selection">
															<RCL searchKey="dates" />
														</span>
													</button>
													<ul className="dropdown-menu" />
												</div>
											</div>
											<div className="star-rating full-width-dd dtc">
												<div className="btn-group">
													<button
														type="button"
														className="btn dropdown-toggle"
														data-toggle="dropdown"
														aria-haspopup="true"
														aria-expanded="false">
														<div className="svg-wrapper" aria-hidden="true">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792">
																<path d="M1728 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z" />
															</svg>
														</div>
														<span className="selection">
															<RCL searchKey="rating" />
														</span>
													</button>
													<ul className="dropdown-menu" />
												</div>
											</div>
											<div className="sort full-width-dd dtc">
												<div className="btn-group">
													<button
														type="button"
														className="btn dropdown-toggle"
														data-toggle="dropdown"
														aria-haspopup="true"
														aria-expanded="false">
														<div className="svg-wrapper" aria-hidden="true">
															<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792">
																<path d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zm0-384q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z" />
															</svg>
														</div>
														<span className="selection">
															<RCL searchKey="sort" />
														</span>
													</button>
													<ul className="dropdown-menu">
														<li>
															<a role="button" href="#" data-value="match">
																<RCL searchKey="match" />
															</a>
														</li>
														<li>
															<a role="button" href="#" data-value="low-price">
																<RCL searchKey="lowest-price" />
															</a>
														</li>
													</ul>
												</div>
											</div>
											<div className="views full-width-dd dtc">
												<div className="btn-group">
													<button type="button" className="btn">
														<span className="list">
															<a role="button" href="#">
																<div className="svg-wrapper" aria-hidden="true">
																	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792">
																		<path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm-1280-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z" />
																	</svg>
																</div>
																<span className="selection">
																	<RCL searchKey="view" />
																</span>
															</a>
														</span>
														<span className="grid">
															<a role="button" href="#" className="active">
																<div className="svg-wrapper" aria-hidden="true">
																	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1792 1792">
																		<path d="M832 1024v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zm0-768v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zm896 768v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zm0-768v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90z" />
																	</svg>
																</div>
																<span className="selection">
																	<RCL searchKey="view" />
																</span>
															</a>
														</span>
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{/* START Page Content */}
						<div className="page-content-container">
							<div id="vf-description">
								<div className="description-copy">
									<p>
										<RCL searchKey="vf-we-have-more-than-200-vacations-that-match-your-request" />
									</p>
								</div>
							</div>
							<div id="vf-results" className="list-view">
								{/* START Promotion Container */}
								<div className="vf-module-content-container" data-row-items={4} />
								{/* END Promotion Container */}
								<div id="vf-pagination" className="hide">
									<nav
										aria-label={RCL({
											searchKey: "vacation-finder-results-by-page",
										})}>
										<ul className="pagination" />
									</nav>
								</div>
							</div>
							<div id="vf-no-filter-results">
								<div className="error-message dt">
									<div className="dtc icon">
										<span className="fa-icon-47 fa-exclamation-circle fa-fw" aria-hidden="true" />
									</div>
									<div className="dtc message" aria-label="Search Results">
										<p>
											<RCL searchKey="sorry-no-results-are-available-based-on-your-filter-settings" />
										</p>
									</div>
								</div>
							</div>
							<div className="vf-disclaimer">
								<p className="micetype">
									<RCL searchKey="vf-all-prices-are-per-person" />
								</p>
							</div>
						</div>
					</div>
				</div>
				<div
					id="generic-modal"
					className="modal light-blue-theme fade"
					tabIndex={-1}
					role="dialog"
					aria-labelledby="modalTitle">
					<div className="modal-dialog modal-lg" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<button
									type="button"
									className="close"
									data-dismiss="modal"
									aria-label={RCL({ searchKey: "modal-close" })}>
									<span aria-hidden="false">
										<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
											<path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
										</svg>
									</span>
								</button>
								<span className="modal-title heading-h2" id="modalTitle" />
							</div>
							<div className="modal-body" />
							<div className="modal-footer">
								<button type="button" className="btn btn-default" data-dismiss="modal">
									<RCL searchKey="modal-close" />
								</button>
							</div>
						</div>
					</div>
				</div>
				<div
					id="compare-modal"
					className="modal light-blue-theme fade"
					tabIndex={-1}
					role="dialog"
					aria-labelledby="compareTitle">
					<div className="modal-dialog modal-lg" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<button
									type="button"
									className="close"
									data-dismiss="modal"
									aria-label={RCL({ searchKey: "modal-close" })}>
									<span aria-hidden="false">
										<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
											<path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
										</svg>
									</span>
								</button>
								<h2 className="modal-title" id="compareTitle">
									<RCL searchKey="compare-hotels" />
								</h2>
							</div>
							<div className="modal-body">
								<div className="compare-top dt" />
								<div className="compare-bottom" />
							</div>
							<div className="modal-footer">
								<div className="compare-footer dt" />
							</div>
						</div>
					</div>
				</div>
				<div
					id="child-age-modal"
					className="modal light-blue-theme fade"
					tabIndex={-1}
					role="dialog"
					aria-labelledby="modalTitle">
					<div className="modal-dialog  modal-sm" role="document">
						<div className="modal-content">
							<div className="modal-body">
								<h2 className="heading" id="childAgeTitle">
									<RCL searchKey="children" />{" "}
									<span>
										<RCL searchKey="0-17-yrs" />
									</span>
								</h2>
								<span className="infants">
									<RCL searchKey="for-infant-select-1" />
								</span>
								<div className="increment-container">
									<a className="button-minus" role="button">
										<span className="sr-only">
											<RCL searchKey="add-a-child" />
										</span>
									</a>
									<span className="selected">0</span>
									<a className="button-plus" role="button">
										<span className="sr-only">
											<RCL searchKey="remove-a-child" />
										</span>
									</a>
								</div>
								<div className="child-age-wrapper" />
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-default" data-dismiss="modal">
									<RCL searchKey="modal-close" />
								</button>
							</div>
						</div>
					</div>
				</div>
				{/* Demo Modal */}
				{config.options.videoDemo && (
					<div
						id="demo-modal"
						className="modal fade"
						tabIndex={-1}
						role="dialog"
						data-backdrop="static">
						<div className="modal-dialog  modal-md" role="document">
							<div className="modal-content">
								<div className="modal-header">
									<button
										type="button"
										className="close"
										data-dismiss="modal"
										aria-label={RCL({ searchKey: "modal-close" })}>
										<span aria-hidden="false">
											<svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
												<path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z" />
											</svg>
										</span>
									</button>
								</div>
								<div className="modal-body">
									<div className="container-fluid no-gutter">
										<div className="row">
											<div className="col-xs-12">
												<div className="demo-placeholder">
													<div className="image">
														<img
															className="demo-image"
															src={cloudinaryBase.concat(
																`/f_auto,q_auto/Dev/vacation-finder/demo/vf-screen-${language}.jpg`
															)}
															alt={RCL({ searchKey: "watch-demo" })}
														/>
														<a role="button" id="watch-demo-icon">
															<i className="fa-icon-47 fa-fw fa-play-circle" aria-hidden="true" />
														</a>
													</div>
													<div className="video">
														<div className="bc-video-container">
															<iframe
																title="Video"
																frameBorder={0}
																allowFullScreen={true}
																webkitallowfullscreen="true"
																mozallowfullscreen="true"
																src="//about:blank"
																data-src="//players.brightcove.net/2208534224001/Hk7rgEeqM_default/index.html?videoId=5992938601001&language=en&autoplay=true"
															/>
														</div>
													</div>
												</div>
												<div className="row">
													<div className="padding-15-top col-xs-12 text-center">
														<a role="button" href="#" className="btn orange watch-demo">
															<RCL searchKey="watch-demo" />{" "}
															<span
																className="fa-icon-47 fa-fw fa-play-circle"
																aria-hidden="true"
															/>
														</a>
													</div>
													<div className="padding-15-top col-xs-12 text-center">
														<a role="button" data-dismiss="modal" className="skip-demo">
															<RCL searchKey="skip" />
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
				{/* END Modal Overlays */}
			</div>
		</>
	);
};

VFinder.propTypes = {
	language: string.isRequired,
	config: object.isRequired,
};

export default VFinder;
export { VFinder };
